var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoBuyerShield = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-3.3%",
  y: "-0.5%",
  width: "106.6%",
  height: "101.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: -2,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.04 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1236.000000, -294.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-1)",
  transform: "translate(1122.000000, 89.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(20.000000, 204.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M99.3192695,8.25412063 L102.943559,8.25381623 L102.942489,13.9992911 C101.075138,12.7147275 99.8582535,10.6493602 99.3192695,8.25412063 Z M108.428177,8.25421404 C107.890771,10.6420058 106.679835,12.7019178 104.822525,13.9872428 L104.821439,8.25381623 Z M104.822333,4.00179652 C106.219363,4.14035417 107.395959,4.59366325 108.705562,5.33312885 C108.731602,5.34781804 108.747793,5.37586105 108.747628,5.40582366 C108.745085,5.73209439 108.731545,6.05583027 108.707063,6.37612031 L104.821439,6.37593639 Z M102.942151,4.00013421 L102.943559,6.37593639 L99.0404932,6.37608239 C99.0160331,6.05580386 99.0025178,5.73208061 99.0000027,5.40582366 C98.9997607,5.37586105 99.0159522,5.34781804 99.0419921,5.33312885 C100.356743,4.59067871 101.537582,4.13669964 102.942151,4.00013421 Z"
}))))));
export default SvgLogoBuyerShield;